import { z } from "zod";

export const queuePositionEnum = z.enum(["last", "next"]);

export type QueuePosition = z.infer<typeof queuePositionEnum>;
